import { apiGet} from "@/utils/apiClient";
import { API_ENDPOINTS } from "@/constants/api";
import { LogoDescribeResponse } from "@/store/brands/types";

export async function fetchDescribeBrandByDomain(domain: string): Promise<LogoDescribeResponse> {
    const describeResponse: LogoDescribeResponse = await apiGet<LogoDescribeResponse>(
        API_ENDPOINTS.logoDescribe(domain),
        { auth: "logoApi" }
    );

    return describeResponse;
}